module.exports = __webpack_public_path__ + "static/media/biglive.d405dfd0.jpg";